export const APP_VERSION = '2.0.02092024';

export const MASTER_ACCOUNT = 'info@arupo.io';

const withTrailingSlash = (value: string): string => {
  if (!value) return value;
  return value.endsWith('/') ? value : `${value}/`;
};

// Fallback keeps current production behavior.
export const REDIRECTION_DATAWEB = withTrailingSlash(
  process.env.REACT_APP_REDIRECTION_DATAWEB || 'https://arupo.io/'
);

// Fallback keeps current production behavior.
export const DATAWEB = process.env.REACT_APP_DATAWEB || 'https://eu-prod.oppwa.com';

export const ENABLE_REDUX_DEV_TOOLS = true;

// test=>000.100.112, prod=>000.000.000
export const DATAFAST_SUCCESS_CODE = process.env.REACT_APP_DATAFAST_SUCCESS_CODE || '000.000.000';

export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK'
};
